"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.SocialAsk = void 0;

require("antd/lib/icon/style");

var _icon = _interopRequireDefault(require("antd/lib/icon"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _class;

var SocialAsk = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(SocialAsk, _Component);

  function SocialAsk(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = SocialAsk.prototype;

  _proto.render = function render() {
    var twitter = this.props.twitter;
    var twitterLink = twitter ? "https://twitter.com/" + twitter : null;
    return _react.default.createElement("div", null, _react.default.createElement("p", null, "If you have ideas, constructive criticism, or just want to say hello, contact us on:"), _react.default.createElement("div", {
      id: "contact"
    }, _react.default.createElement("a", {
      href: twitterLink
    }, _react.default.createElement(_icon.default, {
      type: "twitter"
    }), " Twitter"), " "));
  };

  return SocialAsk;
}(_react.Component)) || _class;

exports.SocialAsk = SocialAsk;